import { Box, Text, VStack, useColorModeValue } from "@chakra-ui/react";
import { keyframes } from "@emotion/react";
import styled from "@emotion/styled/macro";
import { motion } from "framer-motion";

import { FaSpinner } from "react-icons/fa";

const spin = keyframes({
  "0%": { transform: "rotate(0deg)" },
  "100%": { transform: "rotate(360deg)" },
});

const pulse = keyframes({
  "0%, 100%": { opacity: 0.6 },
  "50%": { opacity: 1 },
});

const Spinner = styled(FaSpinner)({
  animation: `${spin} 1s linear infinite`,
  willChange: 'transform',
});

const PulsingText = styled(Text)({
  animation: `${pulse} 2s ease-in-out infinite`,
});

Spinner.defaultProps = {
  "aria-label": "loading",
};

const MotionBox = motion(Box);

export function FullPageSpinner({ message = "Loading..." }) {
  const bgColor = useColorModeValue("gray.50", "gray.900");
  const spinnerColor = useColorModeValue("brand.500", "brand.400");

  return (
    <MotionBox
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      fontSize="3em"
      height="100vh"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      bg={bgColor}
      style={{
        backfaceVisibility: 'hidden',
        perspective: '1000px',
      }}
    >
      <VStack spacing={4}>
        <Box color={spinnerColor}>
          <Spinner />
        </Box>
        <PulsingText
          fontSize="sm"
          color="gray.500"
          fontWeight="medium"
        >
          {message}
        </PulsingText>
      </VStack>
    </MotionBox>
  );
}

// Inline spinner for sections (not full page)
export function SectionSpinner({ message, size = "2em" }) {
  const spinnerColor = useColorModeValue("brand.500", "brand.400");

  return (
    <VStack
      py={8}
      spacing={3}
      align="center"
      justify="center"
    >
      <Box fontSize={size} color={spinnerColor}>
        <Spinner />
      </Box>
      {message && (
        <Text fontSize="sm" color="gray.500">
          {message}
        </Text>
      )}
    </VStack>
  );
}
